/* src/app/dialogs/email-editor/email-editor.component.css */
/*# sourceMappingURL=email-editor.component-VXPDLXNC.css.map */
